import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CustomValidators } from 'ng2-validation';
import { Subscription } from 'rxjs/Subscription';
import { EmissionService } from 'services/emission.service';
import { SpinnerService } from 'services/spinner.service';
import { FooterNavbarService } from 'services/connectors/footer-navbar.service';
import {EventsTravelService} from 'services/calculator-items/events-travel.service';
import { Constants } from 'config/constants';
import { NetworkService } from 'services/network.service';
import { UrlConfig } from 'config/urlConfig';

@Component({
    selector: 'tpc-events-hotel',
    templateUrl: './hotel.component.html',
    styleUrls: ['./hotel.component.css']
})
export class HotelComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;
    private defaultIntValue = 1;
    public isZipValid = true;
    public form: FormGroup;
    public countryList = [];
    public stateList = [];
    public isShown:boolean = true;
    public zipShown:boolean = true;

    constructor(private footerService: FooterNavbarService,
                private emissionService: EmissionService,
                private spinner: SpinnerService,
                private fb: FormBuilder,
                private eventsTravelService: EventsTravelService,
                private networkService: NetworkService
    ) {

        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            this.isZipValid = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
        this.getCountryList();
    }

    private createForm() {
        this.form = this.fb.group({
            country: ['',  [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(50),
                Validators.pattern(/^[A-Za-z0-9,.\-\s]+$/i)]],
            zip: ['', [
                Validators.minLength(3),
                Validators.maxLength(13),
                Validators.pattern(/^[A-Za-z0-9\-\s]+$/i)]],
            attendees: [this.defaultIntValue, [Validators.required,
                CustomValidators.min(1), CustomValidators.max(999999999999), CustomValidators.digits]],
            nights: [this.defaultIntValue, [Validators.required, CustomValidators.min(1),
                CustomValidators.max(99), CustomValidators.digits]],
            state: ['', this.stateValidator],
        });
    }

    private stateValidator = [
        Validators.minLength(1),
        Validators.maxLength(50),
        Validators.pattern(/^[A-Za-z0-9,.\-\s]+$/i)
    ];

    private next() {
        let calculatorName = Constants.calculators.events;
        let categoryName = Constants.categories.events.hotel;
        let zip = (this.form.get('zip').value.length > 0)? this.form.get('zip').value : '0000'
        let subRegion = (this.form.get('state').value.length > 0)? this.form.get('state').value : 'N/A';
        let countryId = (this.form.get('country').value.length > 0)? this.form.get('country').value : 'N/A';

        let params = {
            ZIP: zip,
            numberOfAttendes: this.getFV('attendees'),
            numberOfNights: this.getFV('nights'),
            SubRegion: subRegion,
            CountryID: countryId
        };

        if (this.stateList.length>0)
        {
            if (zip == '0000' && this.stateList.length > 50) {
                this.isZipValid = false;
                return;
            }
            else if(this.form.get('state').value.length=='0')
            {
                this.isZipValid = false;
                return;
            }
            else {}
        }

        this.spinner.show();
        this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
            response => {
                let input = response.body[0].input[0];
                if (input.error) {
                    this.isZipValid = false;
                    this.spinner.hide();
                    return;
                }
                this.eventsTravelService.addToList({
                    category: categoryName,
                    emission: {
                        emission: input.emmission,
                        emissionTrees: input.emissionTrees,
                        DollarAmt: input.DollarAmt,
                        DollarAmtMonthly: input.DollarAmtMonthly
                    }
                });

                this.footerService.skip();
                this.spinner.hide();
            }
        );
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmitted || this.form.get(param).touched);
    }

    getFV(param) {
        return this.form.get(param).value;
    }

    ngOnDestroy() {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

    private getCountryList(): void {
        this.spinner.show();
        this.networkService.post(UrlConfig.getUrl('getStateAndCountry'), { }).subscribe(
        country => {
                this.countryList = country;
                this.spinner.hide();
            }
        );
    }

    public getStateList(state) {
        this.spinner.show();
        this.networkService.post(UrlConfig.getUrl('getStateAndCountry'), {Country: 'US', CountryID: state}).subscribe(
            states => {
                this.stateList = states.sort((a, b) => a.StateAB.localeCompare(b.StateAB));
                if(this.stateList.length > 0)
                {
                    if(this.stateList.length > 50)
                        this.zipShown = true;
                    else
                        this.zipShown = false;
                    //this.form.get('state').setValidators(this.stateValidator.concat(Validators.required));
                    this.isShown = true;
                    if(this.stateValidator.length == 3)
                        this.stateValidator = this.stateValidator.concat([Validators.required]);
                    this.form.updateValueAndValidity();
                    //this.form.get('zip').setValidators([Validators.required]);
                }
                else
                {
                    this.isShown = false;
                    this.zipShown = false;
                    if(this.stateValidator.length == 4)
                        this.stateValidator.splice(this.stateValidator.length - 1,this.stateValidator.length);
                    this.form.get('state').setValidators(this.stateValidator);
                }
                this.spinner.hide();
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/events-calculator/events-travel/hotel/hotel.component.ts